import React from 'react';
import { useFetchLocation } from './useFetchLocation.js';
export const GeoFetcher = ({ children }) => {
    useFetchLocation();
    return children;
};
//# sourceMappingURL=GeoFetcher.js.map